"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'dblogs.col.model': 'Model',
    'dblogs.col.operation': 'Operacja',
    'dblogs.col.recordId': 'ID rekordu',
    'dblogs.col.date': 'Data',
    'dblogs.col.payload': 'Dane wejściowe',
    'dblogs.col.result': 'Wynik',
};
